export default __webpack_public_path__ + "static/media/me8.11cdb813.gif";